import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List as ImmutableList } from 'immutable'
import { fetchMarketplaceListingCategories } from '../../actions/marketplace_listing_categories'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PanelLayout from './panel_layout'
import List from '../list'
import Image from '../image'

class MarketplaceListingCategoriesPanel extends ImmutablePureComponent {

  state = {
    fetched: false,
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.shouldLoad && !prevState.fetched) {
      return { fetched: true }
    }

    return null
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.fetched && this.state.fetched && this.props.isLazy) {
      this.props.dispatch(fetchMarketplaceListingCategories())
    }
  }

  componentDidMount() {
    if (!this.props.isLazy) {
      this.props.dispatch(fetchMarketplaceListingCategories())
      this.setState({ fetched: true })
    }
  }

  render() {
    const { categories = ImmutableList(), isLoading, noPanel, theme } = this.props
    const { fetched } = this.state
  
    const count = !!categories ? categories.count() : 0

    const iconBrightness = ['black', 'muted', 'night'].indexOf(theme) > -1 ? '10' : '0'

    const listItems = categories.map((category) => ({
      to: `/marketplace/listings/${category.get('slug')}`,
      size: 'small',
      title: (
        <div className={[_s.d, _s.flexRow, _s.aiCenter].join(' ')}>
          <div className={[_s.d, _s.circle, _s.bgSecondary, _s.h30PX, _s.w30PX, _s.aiCenter, _s.jcCenter, _s.mr10, _s.overflowHidden].join(' ')}>
            <div style={{ filter: `brightness(${iconBrightness})` }}>
              <Image cfWidthPX='18px' height='18px' width='18px' src={category.get('cover_image_url')} />
            </div>
          </div>
          {category.get('name')}
        </div>
      ),
    }))

    return (
      <PanelLayout
        title='Marketplace Categories'
        noPanel={noPanel}
        noPadding
      >
        <div className={[_s.d, _s.boxShadowNone, _s.boxShadowNoneBg].join(' ')}>
          <List
            scrollKey='marketplace_categories_sidebar_panel'
            items={listItems}
            isLoading={isLoading}
            showLoading={isLoading && !fetched && count === 0}
          />
        </div>
      </PanelLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  theme: state.getIn(['settings', 'displayOptions', 'theme']),
  isLoading: state.getIn(['marketplace_listing_categories', 'isLoading']),
  categories: state.getIn(['marketplace_listing_categories', 'items']),
})

MarketplaceListingCategoriesPanel.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  categories: ImmutablePropTypes.list.isRequired,
}

export default connect(mapStateToProps)(MarketplaceListingCategoriesPanel)
